import { EyeClosedIcon, EyeOpenIcon } from "@/assets";
import {
  AsarDatePicker,
  AsarFormikInput,
  AsarFormikSelect,
} from "@/components";
import { fields, styleLabel, universityYear } from "@/utils";
import {
  Box,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useState } from "react";

function IdentityInfo() {
  const md = useMediaQuery("(max-width:450px)");
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        gap={"10px"}
        sx={{ width: "100%" }}
      >
        <Box display="flex" flexDirection={"row"} gap="10px">
          <Grid
            display={"flex"}
            flexDirection={"column"}
            sx={{ width: "120px" }}
          >
            <AsarFormikSelect
              label="جنسیت"
              name={"sex"}
              data={[
                {
                  id: "MALE",
                  label: "مرد",
                },
                {
                  id: "FEMALE",
                  label: "زن",
                },
              ]}
            />
          </Grid>
          <Grid
            display={"flex"}
            flexDirection={"column"}
            sx={{ width: "calc(100% - 90px)" }}
          >
            <AsarFormikInput
              label={"نام و نام خانوادگی"}
              name={"name"}
              placeholder="نام خود را کامل وارد نمایید."
            />
          </Grid>
        </Box>

        <Grid display={"flex"} flexDirection={"row"} gap={"10px"}>
          <AsarFormikInput
            label={"نام گروه"}
            name={"groupName"}
            placeholder="نام گروه خود را وارد نمایید."
          />
        </Grid>

        <Grid display={"flex"} flexDirection={"row"} gap={"10px"}>
          <AsarFormikInput
            label={"نام پدر"}
            name={"fatherName"}
            placeholder="نام پدر خود را وارد نمایید."
          />

          <AsarFormikInput
            label="کد ملی"
            maxLength={10}
            inputMode="numeric"
            name="nid"
            placeholder="کد ملی خود را بنویسید."
          />
        </Grid>

        <AsarDatePicker
          label={"تاریخ تولد"}
          placeholder="تاریخ تولد خود را انتخاب کنید."
          name={"birthDay"}
        />
        <Grid display={"flex"} flexDirection={"row"} gap={"10px"}>
          <AsarFormikInput
            label={"رمز عبور"}
            name={"password"}
            type={showPassword ? "text" : "password"}
            placeholder={"رمز عبور خود را بنویسید"}
            endAdornment={
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
                aria-label={showPassword ? "مخفی کردن رمز" : "نمایش رمز"}
              >
                {showPassword ? <EyeClosedIcon /> : <EyeOpenIcon />}
              </IconButton>
            }
          />

          <AsarFormikInput
            label={"تکرار رمزعبور"}
            name={"passwordRepeat"}
            type={showRepeatPassword ? "text" : "password"}
            placeholder={"تکرار رمزعبور خود را بنویسید"}
            endAdornment={
              <IconButton
                onClick={() => setShowRepeatPassword(!showRepeatPassword)}
                edge="end"
                aria-label={showRepeatPassword ? "مخفی کردن رمز" : "نمایش رمز"}
              >
                {showRepeatPassword ? <EyeClosedIcon /> : <EyeOpenIcon />}
              </IconButton>
            }
          />
        </Grid>

        <Typography sx={styleLabel}>تحصیلات دانشجویی</Typography>
        <Box display="flex" gap="5px">
          <AsarFormikSelect
            name={"universityYear"}
            width={md ? "80px" : "120px"}
            data={universityYear}
            placeholder="سال"
          />
          <AsarFormikInput
            width={md ? "150px" : "190px"}
            name={"university"}
            placeholder="دانشگاه"
          />

          <AsarFormikSelect
            name={"field"}
            width={md ? "100px" : "140px"}
            data={fields}
            placeholder="رشته"
          />
        </Box>

        <Box
          display="flex"
          mt={"10px"}
          gap="5px"
          justifyContent={"space-between"}
        >
          <AsarFormikSelect
            label={"پایان دوره مسئولیت"}
            name={"endManageYear"}
            width={md ? "80px" : "120px"}
            data={[
              "1400",
              "1401",
              "1402",
              "1403",
              "1404",
              "1405",
              "1406",
              "1407",
              "1408",
              "1409",
              "1410",
              "1411",
            ]}
            placeholder="سال"
          />
          <AsarFormikInput
            width={md ? "150px" : "190px"}
            name={"cid"}
            type="number"
            label="شماره شناسنامه مسئول"
            placeholder="شماره شناسنامه مسئول"
          />
        </Box>
      </Grid>
    </>
  );
}

export default IdentityInfo;
